import ResourcesLanding from './container'
export default ResourcesLanding
